import type { MenuItem } from '@reader-tracker/shared/components/DropdownMenu'

export const APP_NAME = 'Habits'

export const NAV_ITEMS: MenuItem[] = [
  { label: 'Stats', href: '/stats' },
  { label: 'Settings', href: '/settings' },
  { label: 'About', href: '/about' },
]
